export function interopDefault<T>(mod: { default: T } | T): T {
  // @ts-ignore
  return mod.default || mod
}
